/* eslint-disable @stencil-community/required-jsdoc */
import { Component, Host, Listen, State, h, Prop, getAssetPath } from '@stencil/core';
import { Memoize, parseIfString } from '@springbokagency/stencil-base';

import checkWindowSize from '../../../utils/checkWindowSize';

import type { LandingHeroData } from './landing-hero.types';

@Component({
  tag: 'efb-landing-hero',
  styleUrl: 'landing-hero.scss',
  shadow: true,
  assetsDirs: ['assets'],
})
export class EfbLandingHero {
  /**
   * State
   */

  @State() isMobile: boolean = checkWindowSize().isMobile;

  /**
   * Props
   */

  @Prop() data: LandingHeroData | string;

  @Memoize('data')
  get parsedData(): LandingHeroData {
    return parseIfString(this.data);
  }

  /**
   * Events
   */

  @Listen('resize', { target: 'window' })
  handleWindowResize() {
    this.isMobile = checkWindowSize().isMobile;
  }

  /**
   * Render
   */

  render() {
    return (
      <Host>
        <section class="landing-hero">
          <div class="content">
            {/* Title */}
            <h1 class="main-title">
              <span class="text">#FailBetter</span>
              <picture>
                <source
                  srcSet={`${getAssetPath(
                    '/dist/assets/images/logos/logo-fail-better.webp'
                  )}, ${`${getAssetPath(
                    '/dist/assets/images/logos/logo-fail-better@2x.webp'
                  )} 2x`}`}
                  type="image/webp"
                />
                <img
                  class="img"
                  src={getAssetPath('/dist/assets/images/logos/logo-fail-better.png')}
                  srcset={`${getAssetPath('/dist/assets/images/logos/logo-fail-better@2x.png')} 2x`}
                  role="presentation"
                  width="408"
                  height="119"
                />
              </picture>
            </h1>

            {/* Text */}
            {this.parsedData?.introduction && (
              <div class="text-wrapper">
                <efb-paragraph size="md" text={this.parsedData?.introduction} />
              </div>
            )}

            {/* Ethi visual */}
            <div class="ethi-visual">
              <picture>
                <source
                  srcSet={`${getAssetPath(
                    '/dist/assets/images/ethis/ethis-norah.webp'
                  )}, ${`${getAssetPath('/dist/assets/images/ethis/ethis-norah@2x.webp')} 2x`}`}
                  type="image/webp"
                />
                <img
                  class="img"
                  src={getAssetPath('/dist/assets/images/ethis/ethis-norah.png')}
                  srcset={`${getAssetPath('/dist/assets/images/ethis/ethis-norah@2x.png')} 2x`}
                  role="presentation"
                  width="442"
                  height="394"
                />
              </picture>

              {/* Baseline */}
              {this.parsedData?.baseline && (
                <div class="baseline" innerHTML={this.parsedData.baseline}></div>
              )}
            </div>
          </div>

          {/* Curve "mask" */}
          <div class="curves">
            {/* Mobile */}
            {this.isMobile && (
              <svg
                class="curve"
                xmlns="http://www.w3.org/2000/svg"
                width="228"
                height="22"
                viewBox="0 0 228 22"
              >
                <path
                  fill="currentColor"
                  fill-rule="evenodd"
                  d="M139.025281,20.653082 C169.903222,18.1965198 199.754769,11.4618307 228.000908,1.07622209 L228.000783,-14 L228.003906,1.07512 L228,22 L0,22 L-4.50102343e-16,0.1666825 C42.1014804,17.0372509 89.2550355,24.6126628 139.025281,20.653082 Z"
                />
              </svg>
            )}

            {/* Desktop */}
            {!this.isMobile && (
              <svg
                class="curve"
                width="1440"
                height="161"
                viewBox="0 0 1440 161"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 0.208481V161H727.306C415.396 160.904 143.462 96.1392 0 0.208481Z"
                  fill="currentColor"
                />
                <path
                  d="M728.694 161H1440V10.453C1292.89 100.721 1029.37 160.908 728.694 161Z"
                  fill="currentColor"
                />
              </svg>
            )}
          </div>
        </section>
      </Host>
    );
  }
}
